import { render } from "./AppDropZone.vue?vue&type=template&id=5a8c4658&scoped=true&ts=true"
import script from "./AppDropZone.vue?vue&type=script&lang=ts"
export * from "./AppDropZone.vue?vue&type=script&lang=ts"

import "./AppDropZone.vue?vue&type=style&index=0&id=5a8c4658&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8c4658"]])

export default __exports__